import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from '~/elements';
import Icon from '~/elements/Icon';
import { TitleContainer, Title, Description, ContainerButton } from '../common';

const ResetPasswordConfirm = ({ handleSubmit, handleClose, email }) => {
  const handleConfirm = useCallback(() => {
    handleSubmit();
  }, []);

  return (
    <>
      <div className="icon">
        <Icon icon={['fal', 'exclamation-triangle']} />
      </div>

      <TitleContainer>
        <Title>Atenção!</Title>
      </TitleContainer>
      <Description>
        O e-mail informado foi <b>{email}</b> tem certeza de que deseja avançar
        com esse e-mail?
      </Description>

      <ContainerButton>
        <Button
          variant="contained"
          label="Avançar"
          ariaLabel="Avançar"
          style={{ width: 600 }}
          onClick={() => {
            handleConfirm();
          }}
        />
      </ContainerButton>
      <ContainerButton>
        <Button
          color="secondary"
          label="Trocar e-mail"
          ariaLabel="Trocar e-mail"
          style={{ width: 600 }}
          onClick={handleClose}
        />
      </ContainerButton>
    </>
  );
};

ResetPasswordConfirm.propTypes = {
  handleSubmit: PropTypes.func,
  handleClose: PropTypes.func,
  email: PropTypes.string,
};

export default ResetPasswordConfirm;
